import styled from '@emotion/styled';
import { TcolorsPaletteFromBO } from '../../types';

const logoAndBurgerHeight = '80px';
const navigationHeight = '80px';

export const StyledContainer = styled('div')(() => ({
  height: `calc(100dvh - ${logoAndBurgerHeight} - ${navigationHeight})`,
}));

export const StyledEmptySpace = styled('div')(() => ({
  width: '100%',
  height: `calc(100dvh - ${logoAndBurgerHeight} - ${navigationHeight})`,
}));

export const StyledRewardContainer = styled('div')(() => ({
  height: 60,
  padding: '0px 16px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  color: '#4e4e4e',
  borderTop: '1px solid #dbddde',
  borderBottom: '1px solid #dbddde',
  fontFamily: '"RaleWay", "Helvetica", "Arial", sans-serif',
  fontWeight: 700,
  fontSize: 14,
}));

export const StyledRewardIconValue = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  fontWeight: 'normal',
}));

export const StyledRewardValue = styled('div')(
  ({ colorsPaletteFromBO }: { colorsPaletteFromBO: TcolorsPaletteFromBO }) => ({
    color: colorsPaletteFromBO.main,
    fontWeight: 'bold',
  }),
);

export const StyledMenuItemsAndOverlays = styled('div')(() => ({
  height: 'calc(100% - 60px)',
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
}));

// Hide scrollbar for IE, Edge and Firefox
export const StyledMenuItemsContainer = styled('div')(() => ({
  height: '100%',
  width: '100%',
  padding: 16,
  overflowY: 'auto',
  '-ms-overflow-style': 'none' /* IE and Edge */,
  'scrollbar-width': 'none' /* Firefox */,
  '&::-webkit-scrollbar': {
    display: 'none',
  },
}));

export const StyledOpacityOverlay = styled('div')(
  ({ position }: { position: string }) => ({
    position: 'absolute',
    left: 0,
    top: position === 'bottom' ? '90%' : 0,
    width: '100%',
    height: '10%',
    backgroundImage:
      position === 'bottom'
        ? 'linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(162, 175, 188, 0.6))'
        : 'linear-gradient(to top, rgba(255, 255, 255, 0), rgba(162, 175, 188, 0.6))',
    zIndex: 1000,
  }),
);

export const StyledMenuItems = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 32,
  justifyContent: 'center',
}));
